module.exports = __webpack_public_path__ + "img/thumbnail_AfricanBuffalo_f_albino.35902b47.png";